module.exports = __webpack_public_path__ + "img/team-1.2c8d9fd7.jpg";